import React, { useContext, useEffect } from 'react'
import { contextData } from '../../App'
import shirtProof from '../../Assests/FifaFanFest2026ShirtProof.png'

function ShirtOrderPage() {

  const {isScrolled, setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className='pt-[114px]'>

      {/* ── CLOSED MESSAGE ── */}
      <div className='min-h-screen flex flex-col items-center justify-center px-6 text-center'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>FIFA Fan Fest™ Houston 2026</p>
        <div className='flex items-center justify-center gap-4 mb-6'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900 mb-4' style={{fontFamily: "'Playfair Display', serif"}}>
          Shirt Orders <span className='text-[#E40F94] italic'>Closed</span>
        </h1>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mb-8'></div>
        <p className='text-gray-600 text-lg leading-relaxed max-w-xl mb-4'>
          Thank you for your interest! The deadline for the Chilanka FIFA Fan Fest™ Houston 2026 Supporter Shirt has passed.
        </p>
        <p className='text-gray-600 text-lg leading-relaxed max-w-xl mb-10'>
          Orders submitted after <strong>June 4, 2026</strong> cannot be guaranteed.
        </p>
        <div className='flex items-center justify-center gap-3'>
          <div className='h-px bg-[#E40F94] w-16'></div>
          <span className='text-[#E40F94] text-lg'>♦ ◇ ♦</span>
          <div className='h-px bg-[#E40F94] w-16'></div>
        </div>
        <p style={{fontFamily: "'Playfair Display', serif"}} className='text-[#E40F94] italic text-xl mt-8'>
          🌎 One World. One Rhythm. One Chilanka. 🌎
        </p>
      </div>

      {/* ── ORIGINAL PAGE — commented out, reopen by removing the comment wrappers ──

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: inline-block;
          animation: marquee 22s linear infinite;
          white-space: nowrap;
        }
      `}</style>

      <div className='text-center px-6 pt-16 pb-10'>
        <p className='text-[13px] uppercase tracking-[5px] text-[#E40F94] font-semibold mb-3'>FIFA Fan Fest™ Houston 2026</p>
        <div className='flex items-center justify-center gap-4 mb-6'>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 border border-[#E40F94] rotate-45'></div>
          <div className='w-2 h-2 bg-[#E40F94] rotate-45'></div>
          <div className='w-14 h-[1px] bg-[#E40F94]'></div>
        </div>
        <h1 className='font-bold md:text-[48px] text-[32px] leading-tight text-gray-900' style={{fontFamily: "'Playfair Display', serif"}}>
          Chilanka <span className='text-[#E40F94] italic'>Supporter Shirt</span>
        </h1>
        <p className='mt-3 md:text-[18px] text-[16px] text-gray-500 leading-6'>⚽ Light Blue Supporter Shirt Order Form ⚽</p>
        <div className='w-16 h-[3px] bg-[#E40F94] rounded-full mx-auto mt-6'></div>
      </div>

      <div className='flex flex-col items-center'>
        <img
          src={shirtProof}
          alt="Chilanka FIFA Fan Fest 2026 Light Blue Supporter Shirt Mock-up"
          className='w-full max-w-md rounded-2xl shadow-lg border-4 border-[#E40F94]'
        />
        <p className='text-gray-400 text-xs italic mt-3 text-center'>
          Mock-up shown for reference only. Final shirt may vary slightly.
        </p>
      </div>

      <div className='bg-[#E40F94] text-white py-2 overflow-hidden'>
        <div className='marquee-track text-[11px] font-bold tracking-[2px] uppercase'>
          🚨 ORDER DEADLINE: JUNE 4, 2026 &nbsp;✦&nbsp;
          ⚽ PERFORMANCE 1: JUNE 12 @ 4:00 PM &nbsp;✦&nbsp;
          ⚽ PERFORMANCE 2: JUNE 17 @ 7:00 PM &nbsp;✦&nbsp;
          📍 2301 DALLAS ST · HOUSTON TX · EADO &nbsp;✦&nbsp;
          💙 LIGHT BLUE SUPPORTER SHIRT — FAMILY &amp; FRIENDS &nbsp;✦&nbsp;
          🌎 ONE WORLD · ONE RHYTHM · ONE CHILANKA &nbsp;✦&nbsp;
          🚨 ORDER DEADLINE: JUNE 4, 2026 &nbsp;✦&nbsp;
          ⚽ PERFORMANCE 1: JUNE 12 @ 4:00 PM &nbsp;✦&nbsp;
          ⚽ PERFORMANCE 2: JUNE 17 @ 7:00 PM &nbsp;✦&nbsp;
          📍 2301 DALLAS ST · HOUSTON TX · EADO &nbsp;✦&nbsp;
          💙 LIGHT BLUE SUPPORTER SHIRT — FAMILY &amp; FRIENDS &nbsp;✦&nbsp;
          🌎 ONE WORLD · ONE RHYTHM · ONE CHILANKA &nbsp;✦&nbsp;
        </div>
      </div>

      <div className='max-w-3xl mx-auto text-center px-6 py-12'>
        <h2 style={{fontFamily: "'Playfair Display', serif"}} className='text-3xl font-bold text-gray-800 mb-6'>
          Support Our <span className='text-[#E40F94] italic'>Dancers</span>
        </h2>
        <p className='text-gray-600 text-lg leading-relaxed mb-4'>
          Thank you for supporting our dancers as they prepare for their exciting performances at FIFA Fan Fest™ Houston 2026!
        </p>
        <p className='text-gray-600 text-lg leading-relaxed'>
          Parents, grandparents, family, and friends — come out and cheer on Chilanka Dance School as we take the stage at FIFA Fan Fest™ Houston!
        </p>
        <div className='flex items-center justify-center gap-3 mt-8'>
          <div className='h-px bg-[#E40F94] w-16'></div>
          <span className='text-[#E40F94] text-lg'>♦ ◇ ♦</span>
          <div className='h-px bg-[#E40F94] w-16'></div>
        </div>
      </div>

      <div className='bg-gray-50 py-12 px-6'>
        <div className='max-w-4xl mx-auto'>
          <p className='text-[11px] font-bold tracking-[3px] uppercase text-[#E40F94] text-center mb-2'>Location</p>
          <h2 style={{fontFamily: "'Playfair Display', serif"}} className='text-2xl font-bold text-gray-800 text-center mb-2'>📍 FIFA Fan Fest™ Houston</h2>
          <p className='text-center text-gray-600 mb-8'>2301 Dallas St, Houston, TX 77003 · East Downtown (EaDo)</p>
          <p className='text-[11px] font-bold tracking-[3px] uppercase text-[#E40F94] text-center mb-6'>Performance Schedule</p>
          <div className='grid md:grid-cols-2 gap-6'>
            <div className='bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100'>
              <div className='bg-[#E40F94] px-5 py-3 text-center'>
                <p className='text-white font-bold text-sm tracking-wide'>⚽ SUMMER CAMP PERFORMANCE</p>
              </div>
              <div className='px-5 py-5 text-center'>
                <p className='text-gray-800 font-semibold text-lg mb-1'>Chilanka Summer Camp</p>
                <p className='text-[#E40F94] font-bold'>June 12, 2026 · 4:00 PM</p>
              </div>
            </div>
            <div className='bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100'>
              <div className='bg-[#E40F94] px-5 py-3 text-center'>
                <p className='text-white font-bold text-sm tracking-wide'>⚽ DANCE SCHOOL PERFORMANCE</p>
              </div>
              <div className='px-5 py-5 text-center'>
                <p className='text-gray-800 font-semibold text-lg mb-1'>Chilanka Kids + NatyaFusion Women's Team</p>
                <p className='text-[#E40F94] font-bold'>June 17, 2026 · 7:00 PM</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='max-w-3xl mx-auto px-6 py-12'>
        <p className='text-[11px] font-bold tracking-[3px] uppercase text-[#E40F94] text-center mb-6'>Shirt Information</p>
        <div className='space-y-4 mb-10'>
          <div className='flex gap-3 items-start'>
            <span className='text-[#E40F94] text-xl mt-0.5'>✦</span>
            <p className='text-gray-600 leading-relaxed'>🩷 The shirt on this form is the <strong>Light Blue Chilanka FIFA Fan Fest™ Houston 2026 Supporter Shirt</strong>. The image shown is a mock-up — final colors, artwork placement, and design details may vary slightly.</p>
          </div>
          <div className='flex gap-3 items-start'>
            <span className='text-[#E40F94] text-xl mt-0.5'>✦</span>
            <p className='text-gray-600 leading-relaxed'>⚽ Summer Camp dancers will receive an assigned <strong>RED, WHITE, or BLUE</strong> Chilanka FIFA Fan Fest™ T-shirt as part of their camp registration. No additional purchase is required for campers.</p>
          </div>
          <div className='flex gap-3 items-start'>
            <span className='text-[#E40F94] text-xl mt-0.5'>✦</span>
            <p className='text-gray-600 leading-relaxed'>🩷 <strong>Family members, friends, grandparents, and supporters</strong> may purchase the Light Blue Supporter Shirt using this form to show their Chilanka spirit!</p>
          </div>
        </div>
        <div className='flex items-center justify-center gap-3 mt-10'>
          <div className='h-px bg-[#E40F94] w-16'></div>
          <span className='text-[#E40F94] text-lg'>♦ ◇ ♦</span>
          <div className='h-px bg-[#E40F94] w-16'></div>
        </div>
      </div>

      <div className='bg-red-50 border-l-4 border-red-500 mx-6 md:mx-auto md:max-w-3xl rounded-r-xl px-6 py-5 mb-12'>
        <p className='text-red-700 font-bold text-lg mb-1'>🚨 Important Deadline</p>
        <p className='text-red-600 font-semibold'>ALL SHIRT ORDERS MUST BE SUBMITTED BY <span className='underline'>THURSDAY, JUNE 4, 2026</span>.</p>
        <p className='text-red-500 text-sm mt-1'>Orders received after June 4 cannot be guaranteed.</p>
      </div>

      <div className='max-w-4xl mx-auto px-6 pb-16'>
        <p className='text-[11px] font-bold tracking-[3px] uppercase text-[#E40F94] text-center mb-6'>Order Form</p>
        <h2 style={{fontFamily: "'Playfair Display', serif"}} className='text-3xl font-bold text-gray-800 text-center mb-8'>
          Place Your <span className='text-[#E40F94] italic'>Shirt Order</span>
        </h2>
        <div className='bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100'>
          <div className='bg-[#E40F94] px-6 py-4 text-center'>
            <p className='text-white font-bold tracking-wide text-sm text-center'>⚽ CHILANKA FIFA FAN FEST™ HOUSTON 2026 — SHIRT ORDER FORM ⚽</p>
          </div>
          <div className='p-4'>
            <iframe
              id="JotFormIFrame-261496095540159"
              title="Chilanka FIFA Fan Fest™ Houston 2026 — Shirt Order Form"
              onLoad={() => window.parent.scrollTo(0,0)}
              allowTransparency={true}
              allow="geolocation; microphone; camera; fullscreen; payment"
              src="https://pci.jotform.com/form/261496095540159"
              frameBorder="0"
              style={{minWidth:'100%', maxWidth:'100%', height:'1800px', border:'none'}}
              scrolling="yes"
            />
            <script src='https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js'></script>
            <script dangerouslySetInnerHTML={{__html: `window.jotformEmbedHandler("iframe[id='JotFormIFrame-261496095540159']", "https://pci.jotform.com/")`}} />
          </div>
        </div>
      </div>

      <div className='bg-[#E40F94] text-white text-center py-8 px-6'>
        <p style={{fontFamily: "'Playfair Display', serif"}} className='text-2xl italic font-bold'>
          🌎 One World. One Rhythm. One Chilanka. 🌎
        </p>
        <p className='text-white text-sm mt-2 opacity-80'>Thank you for supporting our dancers on the FIFA Fan Fest™ Houston stage!</p>
      </div>

      ── END OF ORIGINAL PAGE ── */}

    </div>
  )
}

export default ShirtOrderPage
